import { AnyObject, createPluginFactory } from '@udecode/plate';
import { BufferValue } from '~/editor/BufferEditor/types.plate';
import {
  ERROR_REPORTING_PLUGIN_KEY,
  withErrorReporting,
} from '~/editor/plugins/error-reporting/withErrorReporting';

export const createErrorReportingPlugin = createPluginFactory<
  AnyObject,
  BufferValue
>({
  key: ERROR_REPORTING_PLUGIN_KEY,
  withOverrides: withErrorReporting,
});
